import {Routes} from '@angular/router';

import {AuthGuard} from './core/auth/auth-guard';
import {clientRoles} from './core/constants/client-roles.config';

export const routes: Routes = [
  {
    path: 'register',
    loadComponent: () => import('./shared/modals/register-modal/register-modal.component').then(m => m.RegisterModalComponent),
  },
  {
    path: 'confirm',
    loadComponent: () => import('./shared/modals/confirm-modal/confirm.component').then(m => m.ConfirmComponent),
  },
  {
    path: 'home',
    loadChildren: () => import('./modules/home/home.routes').then(m => m.routes),
  },
  {
    path: 'newsletters',
    loadChildren: () => import('./modules/newsletter/newsletter.routes').then(m => m.routes),
  },
  {
    path: 'author',
    loadChildren: () => import('./modules/author/author.routes').then(m => m.routes),
    canActivate: [AuthGuard],
    data: {
      expectedRoles: [
        clientRoles.IS_AUTHOR,
      ]
    },
  },
  {
    path: 'topics',
    loadChildren: () => import('./modules/topics/topics.routes').then(m => m.routes),
    canActivate: [AuthGuard],
    data: {
      expectedRoles: [
        clientRoles.IS_USER,
      ]
    },
  },
  {
    path: 'articles',
    loadChildren: () => import('./modules/articles/articles.routes').then(m => m.routes),
    canActivate: [AuthGuard],
    data: {
      expectedRoles: [
        clientRoles.IS_USER,
      ]
    },
  },
  {
    path: 'subadmin',
    loadChildren: () => import('./modules/subadmin/subadmin.routes').then(m => m.routes),
    canActivate: [AuthGuard],
    data: {
      expectedRoles: [
        clientRoles.IS_SUBADMIN,
      ]
    },
  },
  {
    path: 'statistics',
    loadChildren: () => import('./modules/statistics/statistics.routes').then(m => m.routes),
  },
  {
    path: 'admin',
    loadChildren: () => import('./modules/admin/admin.routes').then(m => m.routes),
    canActivate: [AuthGuard],
    data: {
      expectedRoles: [
        clientRoles.IS_ADMIN,
      ]
    },
  },
  {
    path: 'settings',
    loadChildren: () => import('./modules/settings/settings.routes').then(m => m.routes),
  },
  {
    path: 'contact',
    loadChildren: () => import('./modules/contact/contact.routes').then(m => m.routes),
  },
  {
    path: 'privacy',
    loadChildren: () => import('./modules/privacy/privacy.routes').then(m => m.routes),
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];
